<template>
  <div>
    <AppBreadcrumb />

    <FilterAdmisiones />

    <b-card class="principal">

      <div class="d-flex justify-content-between mb-1 mx-1">
        <div class="d-flex text-success align-items-center">
          <i class="fa-solid fa-filter"/>
          <span class="mx-1" v-html="getFiltrosAplicados"></span>
        </div>
        <h5>Resultados: {{ table.totalRows }}</h5>
      </div>

      <b-table 
        v-if="items.length > 0 && !loadingTable" 
        bordered striped responsive 
        :per-page="table.perPage" 
        :items="items"
        :fields="fields" :sort-by.sync="sortBy" 
        :sort-desc.sync="sortDesc" 
        :sort-direction="sortDirection"
      >
        <template #cell(histClin)="data">
          <label v-if="data.item.histClin && data.item.histClin !== '000000'">
            {{ historiaClinicaLocal(data.item) }}
          </label>
          <label v-else style="
            background-color: #DBA5A1;
            color: azure;
            box-shadow: #D9763D;
            border-radius: 3px;
            padding: 3px;
          ">
            {{ data.item.histClin ? data.item.histClin : '' }}

          </label>
        </template>

        <template #cell(cedcar)="data">
          <label v-if="data.item.cedcar" style="
            background-color: #60D93D;
            color: azure;
            
            box-shadow: #60D93D;
            border-radius: 3px;
            padding: 3px;
          ">
            Identificacion Cargada
          </label>
          <label v-else style="
            background-color: #DBA5A1;
            color: azure;
            box-shadow: #D9763D;
            border-radius: 3px;
            padding: 3px;
          ">
            Subir Identificacion
          </label>
        </template>
        <template #cell(acciones)="data">
          <div class="d-flex justify-content-end">

            <b-button variant="info" size="sm" @click="onViewAdmision(data.item.tokenAdmision)">
              <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            </b-button>

            <b-button 
              v-if="hasPermission('adm_editar_admision')" variant="primary" size="sm"
              @click="editItem(data.item.tokenAdmision)">
              <font-awesome-icon icon="user-pen" style="color: white;" />
            </b-button>

            <!-- <b-button 
              v-if="hasPermission('adm_eliminar_admision')" variant="danger" size="sm"
              @click="removeItemid(data.item.id)">
              <font-awesome-icon icon="circle-xmark" style="color: white;" />
            </b-button> -->

          </div>
        </template>
        <template #cell(informes)="data">
          <b-button 
            size="sm" v-b-tooltip.hover title="Descargar formulario 001"
            @click="documentoInforme001(data.item.id)">
            <i class="fas fa-paperclip" style="color:white; font-size: small;" />
          </b-button>
        </template>
      </b-table>

      <b-skeleton-wrapper v-if="loadingTable">
        <b-skeleton v-for="i in 15" :key="i" width="100%" height="50px" />
      </b-skeleton-wrapper>

      <div v-if="items.length == 0 && !loadingTable">
        <p>No se encontraron registros</p>
      </div>

      <b-pagination v-if="items.length > 0" v-model="table.currentPage" :total-rows="table.totalRows"
        :per-page="table.perPage" first-number last-number :small="true" class="mb-0" align="center"
        prev-class="prev-item" next-class="next-item" @change="onChangePage">
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>

    </b-card>

    <b-modal v-model="showModal" @show="cargarComponente" title="Detalles de la persona" size="xl">
      <component :is="componenteDinamico" v-if="componenteDinamico" :token="tokenSeleccionado" />
    </b-modal>

    <VerAdmision />

  </div>

</template>
<script>
import { mapState } from 'vuex';
import { BootstrapVue } from 'bootstrap-vue';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import BCardCode from '@core/components/b-card-code';
import { comprobarPermisos, getEstablecimientoLS } from "@/shared/helpers";
import actions from '@/assets/utils/utils'
import vSelect from 'vue-select'
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import { pacientesService } from '../services';
import { FilterAdmisiones, VerAdmision } from '../components'

export default {
  name: 'ConsultarAdmision',

  components: {
    ...BootstrapVue.components,
    AppBreadcrumb,
    BCardCode,
    vSelect,
    VerAdmision,
    FilterAdmisiones
  },
  data() {

    return {

      establecimientoAdmision: null,

      searchPaciente: '',

      filters: {
        search: null,
        fechaDesde: null,
        fechaHasta: null,
        observaciones: null
      },

      table: {
        currentPage: 1,
        totalRows: 0,
        perPage: 15,
        sortyBy: null,
        sortDesc: false,
      },

      cedulasFalt: false,
      esAdmin: false,
      tokenSeleccionado: null,
      componenteDinamico: null,
      showModal: false,
      cantidadCedulasFaltantes: null,
      mostrarLoader: false,
      login_user: '',
      consultarpac: null,
      sortBy: '',
      sortDesc: false,
      establecimiento: null,
      cantidadNumHistClinic: null,
      establecimientos: [],
      sortDirection: 'asc',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },
      items: [],
      descripcion: '',
      codG: [
        '0000000001', '0000000013', '0000000012', '0000000017', '0000000018', '0000000019', '0000000020'
      ],
    }
  },

  created() {
    comprobarPermisos(this.$route);

    this.setEstablecimientoAdmision();
    this.loadDataTable();
    this.setToken();
  },


  mounted() {
    actions.setearTitulo('Admisiones')
  },


  methods: {

    async loadDataTable() {

      this.loadingTable = true;
      const establecimiento = this.establecimientoAdmision.id;

      const params = {
        ...this.filters,
        establecimiento: establecimiento,
        page: this.table.currentPage,
        pageSize: this.table.perPage
      }

      const responseSearch = await pacientesService.getAll(params);
      if (!responseSearch) return;

      const responseData = responseSearch.pacientes;

      const responseMap = responseData.map(item => {
        const paciente = item.persona;
        const seguroSaludCodigo = item.segsalud?.codigo || '';
        const seguroPrivadoDescripcion = item.seguroprivado?.descripcion || '';
        const seguro = seguroSaludCodigo || seguroPrivadoDescripcion || 'SIN SEGURO';
        return {
          id: item.id,
          tokenAdmision: item.token,
          fechaadm: new Date(item.fechaCreacion).toLocaleString("pt-BR"),
          cedula: paciente.identificacion,
          cedcar: paciente.urlIdentificacion,
          nombres: `${paciente.primerApellido} ${paciente.primerNombre}`,
          seguro,
          usuarioCreador: item.usuarioCreador ? item.usuarioCreador.username : 'No disponible', // Modificado aquí
          // establecimiento : item.establecimiento.Descripcion,
          histClin: item.numHistoriaClinica
        };
      });


      this.table.totalRows = responseSearch.total
      this.items = responseMap;
      this.loadingTable = false
    },


    onChangePage(page) {
      this.table.currentPage = page;
      this.loadDataTable();
    },

    setEstablecimientoAdmision() {
      this.establecimientoAdmision = getEstablecimientoLS();
    },


    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos');
      return permisosUsuario.indexOf(permission) !== -1;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    onRowSelected(items) {
      this.selected = items
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },


    onViewAdmision(token) {
      this.$router.push({ name: 'consultar_admision', query: { view_admision: token } });
    },

    cargarComponente() {
      import('../components/VerAdmision.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    },

    editItem(tokenAdmision) {
      this.$router.push({
        name: 'editar_admision',
        params: { tokenPaciente: tokenAdmision }
      });
    },

    removeItemid(idAdm) {
      this.fetchRemoveAdmision(idAdm);
    },

    async fetchRemoveAdmision(idAdm) {

      this.$swal({
        title: 'Estas seguro de eliminar?',
        text: "No seras capaz de revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Borrar esto!',
        cancelButtonText: 'No, cancelar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const argRmAdm = {
              id: idAdm,
            }
            const response = await axios.post(rutas.axios + 'api', {
              query: `mutation
                  removerAdmision ($id: String!){
                  removerAdmision(idAdm:$id){
                    admision {
                      token
                    }
                    status,
                    message
                  }
                } 
              `,
              variables: argRmAdm
            });

            if (response.status === 200) {
              if (response.data.data.removerAdmision.status === 'success') {
                if (response.status === 200) {
                  this.$swal({
                    title: 'Borrado!',
                    text: 'Tu registro ha sido eliminado',
                    icon: 'success',
                    confirmButtonColor: '#3085d6'
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.$router.go(0);
                    }
                  });
                }
              } else {
                this.$swal({
                  title: 'Error',
                  text: response.data.data.removerAdmision.message,
                  icon: 'error',
                  confirmButtonColor: '#089599',
                })
              }
            }
          } catch (err) {
            console.log(err);
            return 'Error al eliminar admision';
          }
        } else {
          this.$swal({
            title: 'Cancelado',
            text: 'Your registro esta seguro :)',
            icon: 'error',
            confirmButtonColor: '#3085d6'
          });
        }
      });
    },


    async documentoInforme001(idAdmision) {
      let idA = idAdmision;
      idA = idA.toString();

      const query = `
        query MyQuery($idAdmision : String!) {
          documentoInforme001(idAdmision : $idAdmision) {
            message
            pdfarchivo
            status
            admision {
              paciente {
                persona {
                  correo
                }
              }
            }
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables: {
            idAdmision: idA,
          },
        });

        if (response.data.data.documentoInforme001) {
          const item = response.data.data.documentoInforme001[0].pdfarchivo;
          actions.cargarArchivos(
            item,
            "documentoInforme001_" + idA + ".pdf",
            "data:application/pdf;base64"
          );
        } else {
          console.error("Error al descargar el archivo:");
          this.$swal({
            title: "Error",
            text: "El archivo no existe, comunicar con el adminsitrador sistema",
            icon: "error",
            confirmButtonColor: "#089599",
          });
        }

      } catch (error) {
        console.error(error)
        this.$swal({
          title: "Error",
          text: "Error al descargar el archivo",
          icon: "error",
          confirmButtonColor: "#089599",
        });
      }
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },


    historiaClinicaLocal(item) {

      let data = item.histClin.replace(/:\s+/g, ':');  // Elimina los espacios después de los dos puntos

      data = data.replace(/'/g, '"');
      data = data.trim()
      // Ahora que los espacios han sido eliminados, puedes hacer el parseo
      try {
        let parsedData = JSON.parse(data);
        if (parsedData[this.establecimientoAdmision.id]) {
          return parsedData[this.establecimientoAdmision.id]
        } else {
          for (let key in parsedData) {
            if (key === "6") {
              return parsedData[key];
              // Aquí puedes hacer algo si la clave es "6"
            } else if (key === "7") {
              return parsedData[key]
              // Aquí puedes hacer algo si la clave es "7"
            } else {
              return "";
            }
          }
        }
      } catch (e) {
        console.error("Error al parsear el JSON:", e);
      }
      //const historiaClinicaParsed = JSON.parse(item.histClin)

      //console.log("historia que llega", historiaClinicaParsed)


    },

    syncFilters() {
      const newValue = this.stFilterAdmisiones;

      this.filters = {
        search: newValue?.search || null,
        fechaDesde: newValue?.fechaDesde || null,
        fechaHasta: newValue?.fechaHasta || null,
        observaciones: newValue?.observaciones || null
      }

      this.table.currentPage = 1;
    }

  },


  computed: {

    ...mapState({
      stFilterAdmisiones: state => state.generals.filterAdmisiones,
    }),


    fields() {
      return [
        { key: 'fechaadm', label: 'Fecha Reg', sortable: true, thClass: 'text-center' },
        { key: 'cedula', label: '#Identificacion', sortable: true, thClass: 'text-center' },
        { key: 'nombres', label: 'Nombres', sortable: true, thClass: 'text-center' },
        { key: 'seguro', label: 'Seguro', sortable: true, thClass: 'text-center' },
        // {
        //   key: 'histClin',
        //   label: `Hist Clinica IESS`,
        //   sortable: true,
        //   thClass: 'text-center',
        // },
        { key: 'cedcar', label: 'Identificacion Archivo', sortable: true, thClass: 'text-center' },
        { key: 'usuarioCreador', label: 'Usuario', sortable: true, thClass: 'text-center', width: '150px' },
        { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
        // { key: 'informes',        label: 'informes',        sortable: true, thClass: 'text-center', tdClass: 'text-center' },
      ];
    },


    getFiltrosAplicados() {
      const filtrosAplicados = [];

      if(this.filters.search)
        filtrosAplicados.push(`Busqueda: ${this.filters.search}`)

      if(this.filters.fechaDesde)
        filtrosAplicados.push(`Desde: ${this.filters.fechaDesde}`)

      if(this.filters.fechaHasta)
        filtrosAplicados.push(`Hasta: ${this.filters.fechaHasta}`)

      if(this.filters.observaciones === 'sinCedulas')
        filtrosAplicados.push(`Sin cedulas`)

      if(this.filters.observaciones === 'sinHistorias')
        filtrosAplicados.push(`Sin hist. clinicas`)

      return filtrosAplicados.join('<br>');
    }

  },


  watch: {

    stFilterAdmisiones: {
      deep: true,
      handler() {
        this.syncFilters();
        this.loadDataTable();
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>
